import { Box, Button, CircularProgress, OutlinedInput } from "@mui/material";
import { useRef, useEffect, useState, Fragment } from "react";
import { showSnackbar } from "../../../redux/slices/snackbar";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { API_BASE_URL } from "../../../config";

const RESEND_TIMEOUT = 300;

const InputOTP = ({ idUID, setData }) => {
  const inputsRef = useRef([]);
  const [timer, setTimer] = useState(0);
  const [loadingPage, setLoadingPage] = useState(false);
  const navigate = useNavigate();
  const [dataInvioMail, setDataInvioMail] = useState("");
  const [verificaButton, setVerificaButton] = useState(true);

  const dispatchSnackbar = useDispatch();

  const handleSnackbar = (message, severity) => {
    dispatchSnackbar(showSnackbar({ message, severity }));
  };

  useEffect(() => {
    actControl(idUID);
  }, [idUID]);

  async function actControl(idUID) {
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            idUID: idUID,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/actControl`,
        requestOptions
      );

      const responseData = await response.json();

      if (responseData.status === 0 || responseData.status === -1) {
        handleSnackbar(responseData.message, "error");
        navigate("/auth/sign-in", { replace: true });
      }
      setData(responseData.data);
      setDataInvioMail(responseData.data.dataInvioMail);
      setLoadingPage(false);
    } catch (error) {
      console.log(error);
      return error;
    }
  }

  // Helper to parse "25/06/2025 12:55:25" to Date
  function parseDataInvioMail(dateStr) {
    // Format: DD/MM/YYYY HH:mm:ss
    const [datePart, timePart] = dateStr.split(" ");
    const [day, month, year] = datePart.split("/").map(Number);
    const [hour, minute, second] = timePart.split(":").map(Number);
    return new Date(year, month - 1, day, hour, minute, second);
  }

  // Calculate seconds left for timer
  function getSecondsLeft(dataInvioMail, timeoutSeconds) {
    if (!dataInvioMail) return 0;
    const sentDate = parseDataInvioMail(dataInvioMail);
    const now = new Date();
    const expireDate = new Date(sentDate.getTime() + timeoutSeconds * 1000);
    const diff = Math.floor((expireDate - now) / 1000);
    return diff > 0 ? diff : 0;
  }

  useEffect(() => {
    if (!dataInvioMail) return;

    // Set initial timer value
    setTimer(getSecondsLeft(dataInvioMail, RESEND_TIMEOUT));

    // Start interval to update timer every second
    const interval = setInterval(() => {
      setTimer(() => {
        const secondsLeft = getSecondsLeft(dataInvioMail, RESEND_TIMEOUT);
        if (secondsLeft <= 0) {
          clearInterval(interval);
          return 0;
        }
        return secondsLeft;
      });
    }, 1000);

    // Cleanup on unmount or when dataInvioMail changes
    return () => clearInterval(interval);
  }, [dataInvioMail]);

  const handleResend = async () => {
    //Richiamare l'api dell'act-control con inviaMail === 1
    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            inviaMail: 1,
            idUID: idUID,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/actControl`,
        requestOptions
      );

      const responseData = await response.json();

      if (responseData.status === 0 || responseData.status === -1) {
        handleSnackbar(responseData.message, "error");
        navigate("/auth/sign-in", { replace: true });
      }
      setDataInvioMail(responseData.data.dataInvioMail);
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  useEffect(() => {
    if (!loadingPage && inputsRef.current[0]) {
      inputsRef.current[0].focus();
    }
  }, [loadingPage]);

  const sendResult = () => {
    const otp = inputsRef.current.map((input) => input.value).join("");
    if (otp.length === 6) {
      setVerificaButton(false);
    } else {
      setVerificaButton(true);
    }
  };

  const handleSend = async () => {
    // Collect OTP from inputs
    const otp = inputsRef.current.map((input) => input.value).join("");
    console.log("OTP to send:", otp);

    try {
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          data: {
            otp: otp,
            idUID: idUID,
          },
        }),
      };

      const response = await fetch(
        `${API_BASE_URL}/api/otpControl`,
        requestOptions
      );

      const responseData = await response.json();
      console.log(responseData);

      if (responseData.status === 0 || responseData.status === -1) {
        handleSnackbar(responseData.message, "error");
      }
      if (responseData.status === 1) {
        handleSnackbar(responseData.message, "success");
        navigate("/auth/sign-in", { replace: true });
      }
    } catch (error) {
      console.log(error);
      return error;
    }
  };

  const handleOnChange = (e) => {
    const {
      target: { value },
    } = e;

    const nextElementSibling =
      e.target.parentElement?.nextElementSibling?.firstChild;

    if (value.length > 1) {
      e.target.value = value.charAt(0);
      nextElementSibling && nextElementSibling.focus();
    } else {
      if (value.match("[0-9]{1}")) {
        nextElementSibling && nextElementSibling.focus();
      } else {
        e.target.value = "";
      }
    }
    sendResult();
  };

  const handleOnKeyDown = (e) => {
    const { key } = e;
    const target = e.target;
    const previousElementSibling =
      target.parentElement?.previousElementSibling?.firstChild;
    if (key === "Backspace") {
      if (target.value === "" && previousElementSibling) {
        previousElementSibling.focus();
        e.preventDefault();
      } else {
        target.value = "";
      }
      sendResult();
    }
  };

  const handleOnFocus = (e) => {
    e.target.select();
  };

  const handleOnPaste = (e) => {
    const pastedValue = e.clipboardData.getData("Text").replace(/\D/g, ""); // digits only
    let currentInput = 0;

    for (
      let i = 0;
      i < pastedValue.length && currentInput < inputsRef.current.length;
      i++
    ) {
      const pastedCharacter = pastedValue.charAt(i);
      const currentInputElement = inputsRef.current[currentInput];

      if (pastedCharacter.match("[0-9]{1}") && currentInputElement) {
        currentInputElement.value = pastedCharacter;

        const nextElementSibling =
          currentInputElement.parentElement?.nextElementSibling?.firstChild;

        if (nextElementSibling) {
          nextElementSibling.focus();
        }
        currentInput++;
      }
    }

    sendResult();
    e.preventDefault();
  };

  return (
    <Fragment>
      {loadingPage ? (
        <Box
          sx={{
            width: "calc(100vw - 40px)",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <Box display="flex" flexDirection="column" gap={4}>
          <Box sx={{ display: "flex", flexDirection: "row" }}>
            {Array.from(Array(6).keys()).map((i) => (
              <OutlinedInput
                key={i}
                onChange={handleOnChange}
                onKeyDown={handleOnKeyDown}
                onFocus={handleOnFocus}
                onPaste={handleOnPaste}
                inputProps={{
                  maxLength: 1,
                  style: { textAlign: "center" },
                }}
                type="tel"
                inputRef={(el) => (inputsRef.current[i] = el)}
                autoComplete={i === 0 ? "one-time-code" : "off"}
                sx={{
                  height: 40,
                  width: 40,
                  mr: 0.5,
                  ml: 0.5,
                }}
              />
            ))}
          </Box>
          <Box display="flex" justifyContent="center" gap={2}>
            <Button
              variant="outlined"
              color="secondary"
              onClick={handleResend}
              disabled={timer > 0}
            >
              {timer > 0
                ? `Reinvia tra ${Math.floor(timer / 60)
                    .toString()
                    .padStart(2, "0")}:${(timer % 60)
                    .toString()
                    .padStart(2, "0")}`
                : "Reinvia email"}
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={handleSend}
              disabled={verificaButton}
            >
              Verifica
            </Button>
          </Box>
        </Box>
      )}
    </Fragment>
  );
};

export default InputOTP;
